import { TypeEnum } from 'libs/shared-models/masters/src/lib/enums/stock-item-category-status.enum';
import { Column,CreateDateColumn,Entity,PrimaryGeneratedColumn,UpdateDateColumn,} from 'typeorm';

@Entity('vendor_banks')
export class  vendorBanksEntity {
  @PrimaryGeneratedColumn('increment', { name: 'id' })
  id: number;


@Column('varchar', {
    nullable: false,
    // length: 30,
    name: 'bank_name',
})
bankName: string;


    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @Column('varchar', {
        nullable: true,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;




    
}

    
